import React, { useState, useEffect } from "react";
import LeadForm from "./LeadForm";
import Overview from "./Overview";
import Highlights from "./Highlights";
import ConfigPrice from "./ConfigPrice";
import { projectData } from "../data/projectData";
import Amenities from "./Amenities";
import Location from "./Location";
import Developer from "./Developer";
import Gallery from "./Gallery";
import DetailsCard from "../data/DetailsCard";
import MobileDetails from "../data/MobileDetails";
import SideForm from "./SideForm";
import FloorPlans from "./FloorPlans";
import ContactSection from "./Contact";
import Disclaimer from "./Disclaimer";
import StickyCTA from "./StickyCTA";

const Hero = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const bannerImg = data.bannerImg;

  const BannerImages = bannerImg.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % BannerImages);
    }, 3000);

    return () => clearInterval(interval);
  }, [BannerImages]);

  return (
    <>
      <section className="relative min-h-screen flex">
        {/* LEFT SCROLLABLE CONTENT */}
        <div className="w-full lg:w-[75%]">
          <div className="relative w-full h-[50vh] lg:h-screen overflow-hidden">
            <img
              src={bannerImg[currentIndex]}
              alt="Luxury flats in Central Mumbai"
              className="w-full h-full object-cover"
            />

            {/* Overlay Card — ONLY Large Screens */}
            <div className="hidden lg:flex absolute inset-y-0 left-5 items-center">
              <DetailsCard onEnquire={() => setOpen(true)}/>
            </div>
          </div>

          {/* Details Card — BELOW Banner (Small & Medium) */}
          <div className="lg:hidden w-full bg-gradient-to-b from-white to-gray-50 rounded-t-3xl -mt-16 relative z-10">
            <MobileDetails onEnquire={() => setOpen(true)}/>
          </div>

          {/* Long scroll content */}
          <div className="p-5 space-y-5 bg-gray-50">
            <Overview data={projectData} onEnquire={() => setOpen(true)} />
            <Highlights data={projectData}/>
            <ConfigPrice data={projectData} onEnquire={() => setOpen(true)} />
            <FloorPlans data={projectData} onEnquire={() => setOpen(true)} />
            <Amenities data={projectData} />
            <Gallery data={projectData} />
            <Location data={projectData} onEnquire={() => setOpen(true)} />
            <ContactSection />
            <Developer />
            <Disclaimer />
            <StickyCTA onEnquire={() => setOpen(true)} />
          </div>
        </div>

        {/* RIGHT FIXED PANEL */}
        <div className="hidden lg:block fixed right-0 top-0 w-[25%] h-screen bg-white shadow-xl z-40">
          <div className="h-full flex justify-center items-baseline">
            <div className="max-w-sm w-full">
              <SideForm onEnquire={() => setOpen(true)}/>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for ALL screens */}
      {open && <LeadForm modal close={() => setOpen(false)} />}
    </>
  );
};

export default Hero;
